import { Outlet, useLocation } from "react-router-dom";
import { LoadingScreen } from "../common/LoadingScreen";
import { useStorefront } from "../../contexts/StorefrontContext";
import StoreDirectoryPage from "../../pages/StoreDirectoryPage";
import { DirectoryNotFoundPage, StorefrontStatePage } from "../../pages/StorefrontStatePage";
import { getThemeStyle, themes } from "../../themes/themeRegistry";
import { StoreFooter } from "./StoreFooter";
import { StoreHeader } from "./StoreHeader";
import { MobileNav } from "./MobileNav";

export function StoreLayout() {
  const { resolution, viewState, store, previewTheme, setPreviewTheme, retry } = useStorefront();
  const { pathname } = useLocation();
  if (resolution.mode === "directory") {
    return pathname === "/" ? <StoreDirectoryPage /> : <DirectoryNotFoundPage />;
  }
  if (viewState === "loading") return <LoadingScreen />;
  if (viewState !== "ready" || !store) {
    return <StorefrontStatePage state={viewState} retry={viewState === "api-error" ? retry : undefined} />;
  }
  const previewEnabled = import.meta.env.DEV && import.meta.env.VITE_ENABLE_THEME_PREVIEW === "true";
  const focusedCheckout = pathname === "/checkout";
  return (
    <div className={`store-app theme-${previewTheme ?? store.themeId}`} style={getThemeStyle(store, previewTheme)}>
      {!focusedCheckout && <StoreHeader />}
      <main><Outlet /></main>
      {!focusedCheckout && <StoreFooter />}
      {!focusedCheckout && <MobileNav />}
      {previewEnabled && !focusedCheckout && (
        <label className="theme-preview">
          <span>Preview theme</span>
          <select value={previewTheme ?? store.themeId} onChange={(event) => setPreviewTheme(event.target.value as keyof typeof themes)}>
            {Object.values(themes).map((theme) => <option key={theme.id} value={theme.id}>{theme.label}</option>)}
          </select>
        </label>
      )}
    </div>
  );
}
